<template>
<TabView v-model:activeIndex="active">


<TabPanel >

<template #header>
<div class="flex align-items-center gap-1">
    <i class="pi pi-star" style="font-size: 1.5rem"></i>
    <span class="text-sm white-space-nowrap">{{$store.state.languages.lang_phrases.benim_sablonlarim}}</span>
</div>
</template>


<FrameOverlay v-if="loading"></FrameOverlay>


<template v-if="!loading">
<DataTable 
:value="items" 
size="small"
:rows="10"
class="w-12" 
responsiveLayout="scroll"
 >



<Column field="name"  style="max-width: 14rem">
<template #body="{data}">
<p class="text-primary cursor-pointer truncated_text" 
v-tooltip.left="{ value: data.description, disabled: false,class: 'custom-top-tooltip' }"
@click="applyFilter(data.id)"
>{{data.name}}</p>
</template>
</Column>

<Column headerStyle="width: 4rem; text-align: center" bodyStyle="text-align: center; overflow: visible">
<template #body="{data}">

<template v-if="data.share_with_brand_users">
<i class="pi pi-share-alt"></i>
</template>
<template v-else>
<i class="pi pi-share-alt text-purple-500"></i>
</template>

</template>
</Column>

<Column headerStyle="width: 4rem; text-align: center" bodyStyle="text-align: center; overflow: visible">
<template #body="{data}">
<PlannerTableTemplateSidebarTabListItem :data="data" 
@applyFilter="applyFilter"
@editFilter="editFilter"
@shareWithUsers="shareWithUsers"
/>
</template>
</Column>
</DataTable>
</template>

</TabPanel>


<TabPanel>
<template #header>
<div class="flex align-items-center gap-1">
    <i class="pi pi-bookmark" style="font-size: 1.5rem"></i>
    <span class="text-sm white-space-nowrap">{{$store.state.languages.lang_phrases.paylasilmis_sablonlar}}</span>
</div>
</template>
<FrameOverlay v-if="loading"></FrameOverlay>
<template v-if="!loading">
  
</template>

</TabPanel>
</TabView>
</template>

<script>
import PlannerTableTemplateSidebarTabListItem from "./PlannerTableTemplateSidebarTabListItem"
export default {

  name: 'PlannerTableTemplateSidebarTabs',

  data () {
    return {
      active:0,
      loading:false,
      items:[]
    }
  },
  components:{PlannerTableTemplateSidebarTabListItem},
  computed:{

  },
  watch:{
    active()
    {
      console.log("active")
      if(this.active === 0)
      {
        this.getUserFilters()
      }
      if(this.active === 1)
      {
        this.getSharedFilters()
      }
    }

  },
  methods:{
    applyFilter(id)
    {
      let filter = this.items.find(item=>item.id == id)
      this.$emit("applyFilter",filter)
    },
    editFilter(id)
    {
      console.log(id)
    },
    shareWithUsers(id)
    {
      console.log(id)
    },
    async getUserFilters()
    {
      console.log("getUserFilters")
      this.loading = true
      let items = await this.silentApiGet("planningfiltertemplate/get_user_filters") 
      console.log(items)
      this.items = items
      this.loading = false
    },
    async getSharedFilters()
    {
      this.loading = true
      console.log("getSharedFilters")
      let items = await this.silentApiGet("planningfiltertemplate/get_shared_filters") 
      console.log(items)
      this.items = items
      this.loading = false
    },
    showUserFilters()
    {
      this.active = 0
      this.getUserFilters()
    }
  }
}
</script>

<style lang="css" scoped>
</style>